/*
 * View for Engines
 */

define([
  "marionette",
  "modules/accountAdmin/engineAdmin/template/engineAdminTemplate.html",
], function (Marionette, EngineAdminTemplate) {
  var EngineAdminView = {};

  EngineAdminView.engineAdminLayout = Marionette.Layout.extend({
    template: EngineAdminTemplate,
    regions: {
      engineList: "#engineList",
      engineKbList: "#engineKbList",
    },
    triggers: {
      "click #addEngine": "add:engine",
      "click #addEngineKb": "add:engineKb",
    },
  });

  return EngineAdminView;
});
